const _ = require('underscore');
const logger = require('utilities/logger');

var LOCAL_STORAGE_EMULATION_KEY = '__localStorageEmulation';
var localStorageIsSupported;

var Store = (module.exports = {
	/* eslint-disable consistent-return */
	get: function (k) {
		if (!window.readworks) {
			return;
		}
		return window.readworks[k];
	},
	/* eslint-enable consistent-return */
	set: function (k, v) {
		if (!window.readworks) {
			window.readworks = {};
		}
		window.readworks[k] = v;
		if (typeof v === 'function') {
			var queueName = '$' + k + '_queue';
			var queue = this.get(queueName) || [];
			_.each(queue, function (q) {
				v(q);
			});
		}
	},
	inc: function (k) {
		if (!window.readworks) {
			window.readworks = {};
		}

		if (!window.readworks[k]) {
			window.readworks[k] = 0;
		}

		return window.readworks[k]++;
	},
	/**
	 * This function will invoke a function in the store, passing on any remaining arguments.
	 * If there is no function with that name in the store then this is a no-op.
	 * This method exists for 2 reasons:
	 * 1 - we may invoke emit('go-home') before the emit function is there
	 * 2 - Store.call('$emit', 'go-home') is nicer syntax than Store.call('$emit')('go-home')
	 */
	call: function (name) {
		var f = this.get(name);
		var args = Array.prototype.slice.call(arguments);
		args.shift(); // get rid of the name of the function

		if (typeof f === 'function') {
			f.apply(null, args);
		} else {
			var queueName = '$' + name + '_queue';
			var queue = this.get(queueName) || [];
			queue.push(args);
			this.set(queueName, queue);
		}
	},
	checkIfLocalStorageSupported: function () {
		if (typeof localStorageIsSupported === 'undefined') {
			try {
				window.localStorage.setItem('__localStorageTest__', 'abc');
				if (window.localStorage.getItem('__localStorageTest__') !== 'abc') {
					throw new Error('localStorage unsupported');
				} else {
					window.localStorage.setItem('__localStorageTest__', '');
					localStorageIsSupported = true;
				}
			} catch (err) {
				logger.info('localStorage is not supported right now');
				Store.set(LOCAL_STORAGE_EMULATION_KEY, {});
				localStorageIsSupported = false;
			}
		}

		// return true;
		return localStorageIsSupported;
	},
	save: function (k, v) {
		if (Store.checkIfLocalStorageSupported()) {
			localStorage.setItem(k, JSON.stringify(v));
		} else {
			var ls = Store.get(LOCAL_STORAGE_EMULATION_KEY);
			ls[k] = JSON.stringify(v);
		}
	},
	load: function (k) {
		var s;

		if (Store.checkIfLocalStorageSupported()) {
			s = localStorage.getItem(k);
		} else {
			var ls = Store.get(LOCAL_STORAGE_EMULATION_KEY);
			s = ls[k];
		}

		if (s) {
			return JSON.parse(s);
		} else {
			return null;
		}
	},
	delete: function (k) {
		if (Store.checkIfLocalStorageSupported()) {
			localStorage.setItem(k, '');
		} else {
			var ls = Store.get(LOCAL_STORAGE_EMULATION_KEY);
			ls[k] = '';
		}
	}
});
